export default __webpack_public_path__ + "static/media/tools.802956ae.jpg";